import gsap from 'gsap';

export default class Nav {
  constructor(domElement) {
    this.dom = domElement;

    // last scroll position
    // use it for scrolling up/down detection
    this.lastScroll = 0;

    // min threshold for showing the nav
    // {x} percent of window's height
    this.threshold = 100;

    // timeline
    this.TL = gsap.timeline({ paused: true });
    this.TL.to(this.dom, { duration: 0.4, y: '0%', ease: 'power1.inout' });

    this.hidden = true;

    this.init();
  }

  init() {
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (
      window.scrollY > (window.innerHeight * this.threshold) / 100 && //show the nav when leaving the topper
      document.querySelector('.footer__cta__submit').getBoundingClientRect().top -
        window.innerHeight >=
        0 // && show the nav if the footer CTA is out of viewport
    ) {
      this.show();
    } else {
      this.hide();
    }

    // clamp the value to prevent negative scrolling on mobile
    // this.lastScroll = Math.max(window.scrollY, 0);
  }

  show() {
    if (this.hidden) {
      this.hidden = false;
      this.TL.play();
    }
  }

  hide() {
    if (!this.hidden) {
      this.hidden = true;
      this.TL.reverse();
    }
  }

  scrollToTop() {}
}
